/**
 * 格式化时间
 *
 * @param {date} date
 * @param {string} format
 * @returns
 */
import { nodeConfigs, modeConfigs } from "../../config/config.js";
export function formatTime(date, format = 'MM-dd hh:mm') {
  if (!date) return ''
  if (typeof date === 'number') {
    if (Math.floor(date / 1e9) > 0 && Math.floor(date / 1e9) < 10) {
      date = date * 1000
    }
    date = new Date(date)
  } else if (typeof date === 'string') {
    // timestamp in secounds
    if (/^\d{10}$/.test(date)) {
      date = new Date(date * 1000)
    } else {
      // ios 中使用 new Date( yyyy-MM-dd hh:mm:ss:SS ) 时间格式字符串不能精确到 小时以后
      var dateArr = date.split(/[- :]/)
      var now = new Date()
      date = new Date(dateArr[0] || now.getFullYear(), dateArr[1] && parseInt(dateArr[1]) ? parseInt(dateArr[1]) - 1 : (now.getMonth() - 1), dateArr[2] || 1, dateArr[3] || 0, dateArr[4] || 0, dateArr[5] || 0)
    }
  } else {
    /* eslint-disable-next-line */
    console.error('wrong format', date)
    return ''
  }

  if (format === 'timestamp') return +date

  var map = {
    'M': date.getMonth() + 1, // 月份
    'd': date.getDate(), // 日
    'h': date.getHours(), // 小时
    'm': date.getMinutes(), // 分
    's': date.getSeconds(), // 秒
    'q': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds(), // 毫秒
    'W': '星期' + ['日', '一', '二', '三', '四', '五', '六'][date.getDay()] // 星期
  }
  format = format.replace(/([yMdhmsqSW])+/g, function (all, t) {
    var v = map[t]
    if (v !== undefined) {
      if (all.length > 1) {
        v = '0' + v
        v = v.substr(v.length - 2)
      }
      return v
    } else if (t === 'y') {
      return (date.getFullYear() + '').substr(4 - all.length)
    }
    return all
  })
  return format
}

/**
 * "yyyy-MM-dd hh:mm:ss"
 */
export let fulltime = (timestamp) => {
  var date = new Date(timestamp * 1000);
  var Y = date.getUTCFullYear() + "-";
  var M =
    (date.getUTCMonth() + 1 < 10
      ? "0" + (date.getUTCMonth() + 1)
      : date.getUTCMonth() + 1) + "-";
  var D = (date.getUTCDate() < 10 ? "0" + date.getUTCDate() : date.getUTCDate()) + " ";
  var h = (date.getUTCHours() < 10 ? "0" + date.getUTCHours() : date.getUTCHours()) + ":";
  var m = (date.getUTCMinutes() < 10 ? "0" + date.getUTCMinutes() : date.getUTCMinutes()) + ":";
  var s = date.getUTCSeconds() < 10 ? "0" + date.getUTCSeconds() : date.getUTCSeconds();
  return Y + M + D + h + m + s;
  //return formatTime(timestamp, "MM-dd hh:mm:ss")
}

/*
 * 截断hash
 */
export let filterHash = str => String(str).substr(0, 16) + '...' + String(str).substr(-4);


// 省略中间 x 位 为了方便记忆 展示后4位
export let addressEll = (str) => {
  if (!str) return ''
  return str.replace(/^(\w{6})(\w+)(\w{4})$/, '$1...$3')
}


// 校验地址是否包含中文
export let addressCN = (str) => {
  let valid = /.*[\u4e00-\u9fa5]+.*$/.test(str)
  return valid
}

// 校验url合法性
export let checkURL = (str) => {
  /* eslint-disable */
  let urlRule = "^((https|http|ftp|rtsp|mms)?://)" +
    "(([0-9]{1,3}\.){3}[0-9]{1,3}" // IP形式的URL- 199.194.52.184
    +
    "|" // 允许IP和DOMAIN（域名）
    +
    "([0-9a-z_!~*'()-]+\.)*" // 域名- www.
    +
    "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\." // 二级域名
    +
    "[a-z]{2,6})" // first level domain- .com or .museum
    +
    "(:[0-9]{1,4})?" // 端口- :80
    +
    "((/?)|" // a slash isn't required if there is no file name
    +
    "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$"
  /* eslint-enable */
  let valid = new RegExp(urlRule)
  return valid.test(str)
}

let checkIsMobile = function () {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  let width = document.documentElement.clientWidth;
  return !!(flag || width <= 500)
}

let isAddress = function (address) {
  if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
    // check if it has the basic requirements of an address
    return false;
  } else if (/^(0x)?[0-9a-f]{40}$/.test(address) || /^(0x)?[0-9A-F]{40}$/.test(address)) {
    // If it's all small caps or all all caps, return true
    return true;
  } else {
    // Otherwise check each case
    return isChecksumAddress(address);
  }
};

export var isChecksumAddress = function (address) {
  // Check each case
  address = address.replace('0x', '');
  // var addressHash = sha3(address.toLowerCase());
  // for (var i = 0; i < 40; i++ ) {
  //     // the nth letter should be uppercase if the nth digit of casemap is 1
  //     if ((parseInt(addressHash[i], 16) > 7 && address[i].toUpperCase() !== address[i]) || (parseInt(addressHash[i], 16) <= 7 && address[i].toLowerCase() !== address[i])) {
  //         return false;
  //     }
  // }
  return true;
};

export let getNameWithChainId = (chainId) => {
  var config = nodeConfigs
  var res = config.filter(item => item.chainId == chainId)
  //console.log("getNameWithMode", chainId, config, res)
  if (res && res.length > 0) {
    return res[0].name
  }
  return ""
}
export let getNameWithMode = (str) => {
  var config = modeConfigs
  var res = config.filter(item => item.mode == str)
  // console.log("getNameWithMode", str, config, res)
  if (res && res.length > 0) {
    return res[0].name
  }
  return ""
}
export let getNameWithSwapAddress = (address) => {
  var config = nodeConfigs
  var chainId = localStorage.getItem("TokenBox-chainID")
  var res = config.filter(item => item.chainId == chainId)
  console.log("getNameWithAddress=",res,chainId)
  if (res && res.length > 0) {
    var nodeData = res[0].swap;
    var nameArr = nodeData.filter(item => item.value.toLowerCase() == address.toLowerCase())
    console.log("nameArr=",nameArr)
    if (nameArr && nameArr.length > 0) {
      return nameArr[0].label
    }
  } 
  return ""
}
export let getNameWithCurrencyAddress = (address) => {
  var config = nodeConfigs
  var chainId = localStorage.getItem("TokenBox-chainID")
  var res = config.filter(item => item.chainId == chainId)
  console.log("getNameWithAddress=",res)
  if (res && res.length > 0 ) {
    var nodeData = res[0].currency;
    var nameArr = nodeData.filter(item => item.value.toLowerCase() == address.toLowerCase())
    console.log("nameArr=",nameArr)
    if (nameArr && nameArr.length > 0) {
      return nameArr[0].label
    }
  }

  return ""
}
export let showErrorMessage = (error) => {
  console.error('showErrorMessage:', error);
  var str = error;
  if (error.message) {
    str = (error.message).toLowerCase()
  }
  if (error.data && error.data.message) {
    str = error.data.message
  }
  if (str.includes('user rejected transaction')) {
    str = "本次交易已取消"
  }
  if (str.includes('insufficient funds')) {
    str = "钱包余额不足"
  }
  if (str.length > 150) {
    str = str.substr(0, 150) + "......"
  }
  Vue.prototype.$message({
    message: str,
    type: "warning",
  });
}
export default {
  formatTime,
  fulltime,
  filterHash,
  checkIsMobile,
  addressEll,
  addressCN,
  checkURL,
  isAddress,
  getNameWithMode,
  getNameWithSwapAddress,
  getNameWithCurrencyAddress,
  getNameWithChainId,
  showErrorMessage
}
import Vue from 'vue';
Vue.prototype.$showErrorMessage = showErrorMessage;
Vue.prototype.$isAddress = isAddress;